<template>
  <div class="container">
    <van-cell-group class="group">
      <van-field
        placeholder="姓名"
        label="姓名"
        v-model.trim="form.name"
        clearable
        label-width="96px"
      />
      <van-field
        v-if="userInfo.phoneNumber"
        placeholder="手机号"
        label="手机号"
        type="tel"
        :value="userInfo.phoneNumber"
        readonly
        label-width="96px"
      />
      <van-field
        v-if="!userInfo.phoneNumber"
        placeholder="手机号"
        label="手机号"
        type="tel"
        v-model="form.phoneNumber"
        label-width="96px"
      />
      <!-- <van-field
        placeholder="担保人手机号"
        label="担保人手机号"
        type="tel"
        v-model="form.guaranteePhone"
        clearable
        label-width="96px"
      />
      <van-field
        placeholder="出货编号"
        label="出货编号"
        v-model="form.account"
        clearable
        label-width="96px"
      /> -->
      <!-- <van-field
        placeholder="身份证"
        label="身份证"
        v-model="form.idCard"
        clearable
        label-width="96px"
      /> -->
      <!-- <van-field
        readonly
        clickable
        label="出生日期"
        :value="form.birthDay"
        is-link
        arrow-direction="down"
        placeholder="年 月 日"
        @click="showPicker = true"
        label-width="96px"
      />
      <van-popup v-model="showPicker" round position="bottom">
        <van-datetime-picker
          v-model="currentDate"
          type="date"
          title="选择年月日"
          :min-date="minDate"
          :max-date="maxDate"
          @cancel="showPicker = false"
          @confirm="onConfirm"
        />
      </van-popup>
      <van-field
        placeholder="性别"
        label="性别"
        :value="form.sex"
        is-link
        arrow-direction="down"
        clickable
        readonly
        @click="showGender = true"
        label-width="96px"
      />
      <van-popup v-model="showGender" round position="bottom">
        <van-picker
          title="选择性别"
          show-toolbar
          :columns="columns"
          v-model="form.sex"
          @cancel="showGender = false"
          @confirm="Confirm"
        />
      </van-popup> -->
    </van-cell-group>
    <div class="bottom" @click="onSubmit(form)">
      <button class="button">提交</button>
    </div>
  </div>
</template>
<script>
import {
  CellGroup,
  Form,
  Field,
  Notify,
  Button,
  DatetimePicker,
  Popup,
  Toast,
  Picker,
  Dialog,
} from "vant";
import { dateFormat } from "../../util/date";
import { mapGetters,mapActions } from "vuex";
import service from "../../api/employeePage/index";
export default {
  components: {
    [CellGroup.name]: CellGroup,
    [Form.name]: Form,
    [Field.name]: Field,
    [Notify.name]: Notify,
    [Button.name]: Button,
    [DatetimePicker.name]: DatetimePicker,
    [Popup.name]: Popup,
    [Toast.name]: Toast,
    [Picker.name]: Picker,
    [Dialog.name]: Dialog,
  },
  data() {
    return {
      name: "",
      tel: "",
      form: {
        name: "",
        phoneNumber: "",
        // guaranteePhone: "",
        // account: ""
        // birthDay: "",
        // sex: "",
        // gender: ""
      },
      showmode: true,
      minDate: new Date(1920, 0, 1),
      maxDate: new Date(2025, 10, 1),
      currentDate: new Date(),
      isShow: false,
      showGender: false,
      showPicker: false,
      columns: ["男", "女"],
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  mounted() {},
  methods: {
    ...mapActions([ "buyAgentStatus"]),
    // 清除缓存
    onClear () {
      localStorage.removeItem("__cartinfo__");
      localStorage.removeItem("__userinfo__");
      this.buyAgentStatus({ show: false });
      Toast("请重新登录");
      this.$router.replace("login");
    },
    onConfirm(value, index) {
      this.form.birthDay = dateFormat(value);
      this.showPicker = false;
    },
    Confirm(value) {
      this.form.sex = value;
      this.showGender = false;
    },
    onSubmit(form) {
      // var phoneReg =
      //   /^((13[0-9])|(14[0-9])|(15[0-9])|(16[0-9])|(17[0-9])|(18[0-9]))\d{8}$/;
      var accountReg = /^B|C|b|c/;
      var phoneReg = /^(1[0-9])\d{9}$/;
      // var date = /^\d{4}(\-)\d{1,2}\1\d{1,2}$/;
      // var IDCard =
      //   /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      var Name = /^([a-zA-Z0-9\u4e00-\u9fa5\·]{1,10})$/;
      if (this.form.name == "") {
        Notify({ type: "danger", message: "请输入姓名" });
        return;
      }
      if (!Name.test(this.form.name) && this.form.name.length > 9) {
        Notify({ type: "danger", message: "姓名格式不正确" });
        return;
      }
      if (this.userInfo.phoneNumber) {
        this.form.phoneNumber = this.userInfo.phoneNumber;
      }

      if (this.form.phoneNumber == "") {
        Notify({ type: "danger", message: "请输入手机号" });
        return;
      }
      if (!phoneReg.test(this.form.phoneNumber)) {
        Notify({ type: "danger", message: "手机号格式不正确" });
        return;
      }
      // if (this.form.guaranteePhone == "") {
      //   Notify({ type: "danger", message: "请输入担保人手机号" });
      //   return;
      // }
      // if (!phoneReg.test(this.form.guaranteePhone)) {
      //   Notify({ type: "danger", message: "手机号格式不正确" });
      //   return;
      // }
      // if (this.form.account.trim() == "") {
      //   Notify({ type: "danger", message: "请输入出货编号" });
      //   return;
      // }
      // if (!accountReg.test(this.form.account)) {
      //   Notify({ type: "danger", message: "请输入正确的出货编号" });
      //   return;
      // }
      // if (this.form.idCard == "") {
      //   Notify({ type: "danger", message: "请输入身份证号码" });
      //   return;
      // }
      // if (!IDCard.test(this.form.idCard)) {
      //   Notify({ type: "danger", message: "身份证格式不正确" });
      //   return;
      // }
      // if (this.form.birthDay == "") {
      //   Notify({ type: "danger", message: "请选择出生日期" });
      //   return;
      // }
      // if (!date.test(this.form.birthDay)) {
      //   Notify({ type: "danger", message: "日期格式不正确" });
      //   return;
      // }
      // if (this.form.sex == "") {
      //   Notify({ type: "danger", message: "请选择您的性别" });
      //   return;
      // }

      // let value = this.$route.query;
      // var fileupload = {
      //   userName: value.userName,
      //   password: value.password,
      //   shareCode: value.shareCode
      // };
      // fileupload.name = this.form.name;
      // fileupload.phoneNumber = this.form.phoneNumber;
      // fileupload.guaranteePhone = this.form.guaranteePhone;
      // fileupload.account = this.form.no;
      // fileupload.idCard = this.form.idCard;
      // fileupload.birthDay = this.form.birthDay;
      // if (this.form.sex == "女") {
      //   this.form.gender = 1;
      // }
      // if (this.form.sex == "男") {
      //   this.form.gender = 0;
      // }
      // fileupload.gender = this.form.gender;
      // localStorage.setItem("userMes", JSON.stringify(fileupload));
      Dialog.confirm({
        message:
          "请确认好自己的个人信息是否正确，如果信息错误店长审核将不会给予通过",
      })
        .then(() => {
          // on confirm
          // this.form.account = this.form.account.trim().toLowerCase().replace(this.form.account[0], this.form.account[0].toUpperCase())
          service
            .post(this.form)
            .then((res) => {
              if (res.statusCode == 200) {
                this.$router.replace({
                  name: "invitationSuccess",
                  query: { status: true },
                });
                this.onClear()
              } else {
                Toast(res.errors);
                Notify({
                  type: "danger",
                  message: res.errors,
                });
                this.$router.replace({
                  name: "invitationSuccess",
                  query: { status: false },
                });
              }
            })
            .catch((err) => {
              if (err.status == 400) {
                this.$router.replace({
                  name: "invitationSuccess",
                  query: { status: false },
                });
                Toast(err.data);
              }
            });
          // this.$router.push({ name: "upload", query: { form: this.form } });
        })
        .catch(() => {
          // on cancel
        });
    },
  },
};
</script>
<style lang="less" scoped>
@deep: ~">>>";

.container {
  // height: calc(100% - 46px);
  overflow: auto;
  display: flex;
  flex-direction: column;
  height: 100vh;
  justify-content: space-between;
  .van-cell {
    font-size: 4vw;
    height: 14.4vw;
    padding: 0 6vw;
    line-height: 14.4vw;
    @{deep}.van-field__label {
      color: #000;
    }
    @{deep}.van-field__control {
      color: #919191;
      font-size: 4vw;
    }
  }
  @{deep} .van-cell__right-icon {
    height: 14vw;
    font-size: 4.26667vw;
    line-height: 14vw;
  }
  .group {
    box-shadow: 0px 18px 23px 1px rgba(0, 0, 0, 0.03);
    .van-cell {
      @{deep}.van-cell__title,
      .van-cell__value {
        flex: none;
        text-align: left;
      }
    }
  }
  .bottom {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-bottom: 55px;
    .button {
      width: 305px;
      height: 45px;
      border: 0;
      color: #fff;
      background: linear-gradient(0deg, #d8051d, #f5586b);
      border-radius: 21px;
      margin-top: 33px;
    }
  }
}
</style>
